import { FeatureEntry, getFeatureFilterHref } from "utils/featureFilters"

interface Props {
  features: FeatureEntry[]
  collectionHref?: string
}

const TokenFeatures = ({ features, collectionHref }: Props) => {
  if (features.length === 0) return null

  return (
    <div className="mb-8">
      <h2 className="gallery-label text-gallery-muted mb-4">Features</h2>
      <div className="divide-y divide-gallery-border">
        {features.map((feature) => {
          const href = collectionHref ? getFeatureFilterHref(collectionHref, feature) : undefined
          return (
            <div key={`${feature.name}-${feature.value}`} className="flex justify-between gap-4 py-3">
              <span className="text-sm text-gallery-muted">{feature.name}</span>
              {href ? (
                <a
                  href={href}
                  className="text-sm text-gallery-text text-right gallery-link"
                  title={`View other works with ${feature.name}: ${feature.value}`}
                >
                  {feature.value}
                </a>
              ) : (
                <span className="text-sm text-gallery-text text-right">{feature.value}</span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TokenFeatures
